<template>
  <div>
    <v-row>
      <v-col
        :cols="isMobile ? 12 : 4"
        v-for="(dataArr, i) in clientData"
        :key="i + Math.random() + Math.random()"
        class="ml-8 pt-2"
      >
        <CardAlert :color="getThemeColor" class="mb-2">
          <v-text-field
            :label="dataArr[0].toUpperCase().replace('_', ' ').split(' ')[0]"
            v-if="isAdmin"
            class="mx-2 mb-n10"
            :value="dataArr[1]"
            @change="updateField(dataArr[0], client.id)"
          ></v-text-field>
          <span
            v-else
            class="mx-2 mt-n6"
            @change="updateField(dataArr[0], client.id)"
            >{{ dataArr[1] }}</span
          >
        </CardAlert>
      </v-col></v-row
    >
  </div>
</template>

<script>
import helpersJs from "@/plugins/helpers";
import CardAlert from "@/components/myLibrary/CardAlert.vue";

export default {
  props: {
    client: {
      default: null,
    },
    table: {
      default: "clients",
    },
  },
  watch: {
    client(newClient) {
      this.getUserProfile(newClient);
    },
  },
  components: { CardAlert },
  computed: {
    isMobile() {
      return this.$store.getters.isMobile;
    },
    isAdmin() {
      return this.$store.getters.isAdmin;
    },
    getThemeColor() {
      return this.$store.getters.getThemeColor;
    },
  },
  mounted() {
    this.getUserProfile(this.client);
  },
  data: () => ({
    clientData: [],
    selectedClient: null,
  }),
  methods: {
    getUserProfile(client) {
      if (client != null) {
        this.clientData = [];
        const clientData = Object.entries(client);
        clientData.forEach((dataArr) => {
          if (
            dataArr[0] != "id" &&
            dataArr[0] != "emis" &&
            !dataArr[0].includes("sub_") &&
            typeof dataArr[1] != "object" &&
            !dataArr[0].includes("_at")
          ) {
            this.clientData.push(dataArr);
          }
        });
      }
    },
    async updateField(column, id) {
      const value = event.target.value;
      const client = await helpersJs.updateModelSingleRow(
        this.table,
        column,
        id,
        value
      );
      this.selectedClient = client;
      this.$emit("data-updated", client);
      this.getUserProfile();
      this.$toast.success("Data Updated Successfully!", { duration: 3000 });
    },
  },
};
</script>

<style></style>
